<div class="col-12 col-am-12 col-md-10 col-lg-10 mx-auto">
    <div class="row mt10">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 pl4">
            <div class="clear50"></div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-9">
                <img class="moblogo" src="./assets/images/TL-Logo.svg">
                <div class="clear30"></div>
                <!-- <label class="semi-bold fs-36 m-0 pl18 blue tabfs24 mobfs-22"><span class="txt-blue">Broker Self-Help</span> Portal </label>
                <div class="clear20"></div>
                <p class="fs-20 blue regular pl18 tabfs18 mobfs-16">Manage and create login accounts for your staff members in different departments. It’s simple and easy.</p>
                <p class="fs-20 blue regular pl18 tabfs18 mobfs-16">Take onto Travelance on-boarding journey with our seamless self-service portal designed for Brokers.</p> -->
                <div class="mobcenter">
                    <label class="semi-bold fs-36 m-0 pl18 blue tabfs24 mobfs-22"><span class="txt-blue">MyTL</span> Portal </label>
                </div>
                <div class="clear20"></div>
                <!-- <p class="fs-20 blue regular pl18">Manage and create login accounts for your staff members in different departments. It’s simple and easy.</p> -->

                <p class="fs-20 blue regular pl18 tabfs16 mobfs-14 mobcenter">From one location, you can:</p>
                <ul class="fs-20 blue regular pl60 tabfs16 mobfs-12">
                    <li>Access your Travelance account </li>
                    <li>Complete online training</li>
                    <li>Sell and administer policies</li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mobpad7">
            <div class="col-12 col-sm-12 col-md-10 col-lg-9 pad32 ml60 box">
                <form [formGroup]="SetPassword" (ngSubmit)="onSubmit()">

                    <label class="fs-20 blue regular m-0 tabfs18">Set your own Password</label>
                    <div class="clear10"></div>
                    <label class="semi-bold black fs-16 tabfs14">New Password</label>
                    <div class="clear"></div>
                    <input type="{{type}}" formControlName="newPassword" [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }" class="instyle regular w-100 olnone" autocomplete="off" (input)="test()">
                    <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShow()">

                    <p class="fs-12 regular">* Password must be between 8-16 characters and include at least one upper-case letter, one lower-case letter, one number, and one special character. Special characters allowed: !@#$%^&*()-+</p>
                    <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                        <!-- <div *ngIf="f.newPassword.errors.required">New Password is required</div> -->
                        <div *ngIf="f.newPassword.errors.pattern">Password is not in the required format.</div>
                    </div>
                     <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                    <div *ngIf="f.newPassword.value.length>15">Password characters exceeds the maximum allowed limit.</div>
                </div>
                    <div class="clear10"></div>
                    <label class="semi-bold black fs-16 tabfs14">Confirm Password</label>
                    <div class="clear"></div>
                    <input type="{{type1}}" formControlName="confirmPassword" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" class="instyle regular w-100 olnone" autocomplete="off" (input)="test()">
                    <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShow1()">

                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                        <!-- <div *ngIf="f.confirmPassword.errors.required">Comfirm Password is required</div> -->
                        <div *ngIf="f.confirmPassword.errors.pattern">Password is not in the required format.</div>
                        </div>
                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="f.confirmPassword.value.length>15">Password characters exceeds the maximum allowed limit.</div>
                    </div>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-1 col-sm-1 col-md-1 col-lg-1">
                            <input type="checkbox" [checked]="rememberMeChecked1 == true" value="true" (change)="onSelected($event)">
                        </div>
                        <div class="col-11 col-sm-11 col-md-11 col-lg-11">
                            <label class="fs-14 regular black">By checking this box you agree to Travelance Inc. collecting your information as required to fulfill your request to sign up and continue your partnership with Travelance.</label>
                            <label class="fs-14 regular black">For more information on how your personal information will be stored, collected, and used, please review our <a class="txt-blue3 cp" href="https://www.travelance.ca/privacy-policy/" target="_blank"><u>Privacy Policy.</u></a></label>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="clear5"></div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right btncenter">
                        <!-- <button type="button" class="proceedbtn semi-bold olnone" routerLink="/dashboard">Update Password and Login</button> -->
                        <button [disabled]="loading" (click)="onSubmit()" type="submit" class="proceedbtn semi-bold olnone">Create Password and Login</button>
                    </div>
                    <div class="clear10"></div>
                    <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                </form>
            </div>
        </div>
    </div>
</div>




<!-- <p class="abc">login-page works!</p>
<p>
    <button type="button" class="btn  retrybtn fs-16 regular" (click)="goToHome()">
       CLICK</button>  
</p> -->